<script>
// qr component
// import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  components: {
    // VueQrcode
  },
  props: {
    qrContent: {
      type: String,
      default:
        'https://lanhuapp.com/web/#/item/project/board/detail?pid=81fecfed'
    },
    companyLogo: {
      type: String,
      default:
        'https://z1.muscache.cn/im/pictures/b1d2aed9-3bc4-4057-898e-7a17a04cc87f.jpg?aki_policy=xx_large'
    }
  }
}
</script>
<template>
  <div class="follow_guide">
    <div class="follow_guide_qrcode">
      <img :src="companyLogo" class="follow_guide_company_logo" />
      <img :src="qrContent" class="follow_guide_qrCode_image" />
      <!-- <VueQrcode :value="qrContent" :options="{ width: 91 }"></VueQrcode> -->
    </div>
    <div class="follow_guide_content">
      <span>微信扫码围观工地</span>
      <span>及时接收工地更新动态～</span>
    </div>
  </div>
</template>
style
<style lang="scss">
.follow_guide {
  display: flex;
  height: 113px;
  padding: 15px 20px;
  .follow_guide_qrcode {
    position: relative;
    .follow_guide_company_logo {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: 18px;
      height: 18px;
    }

    .follow_guide_qrCode_image {
      width: 80px;
      height: 80px;
    }
  }
  .follow_guide_content {
    // margin-top: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 15px;
    line-height: 24px;
    > span {
      display: block;
      line-height: 24px;
    }
  }
}
</style>
